import useResizeObserver from '@react-hook/resize-observer';
import { useState, useCallback, useLayoutEffect } from 'react';
import { getBreakpointNameByWidth, withinBreakpoint } from '../../../../helpers/breakpoints/breakpoints.js';

// TODO: Evaluate if breakpoints can be optional (using a set of default Breakpoints)

const useBreakpoints = (_containerRef, breakpoints) => {
  const [currentBreakpoint, setCurrentBreakpoint] = useState();
  const containerRef = _containerRef === 'window' ? null : _containerRef;
  const setBreakpointByWidth = useCallback(width => {
    const breakpointName = getBreakpointNameByWidth(width, breakpoints);
    setCurrentBreakpoint(breakpointName);
  }, [breakpoints]);
  useResizeObserver(containerRef, entry => {
    const {
      width
    } = entry.contentRect;
    setBreakpointByWidth(width);
  });
  useLayoutEffect(() => {
    // If the containerRef is not set, we use listen to the resize event
    const handleResize = () => {
      setBreakpointByWidth(window.innerWidth);
    };

    // Observe the size of the container element.
    if (containerRef) {
      const width = containerRef.current?.getBoundingClientRect().width || 0;
      setBreakpointByWidth(width);
    } else {
      // If the containerRef is not set, we use listen to the resize event
      window.addEventListener('resize', handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
    }
    return () => {
      if (!containerRef) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [breakpoints, containerRef, setBreakpointByWidth]);
  const within = useCallback((min, max) => withinBreakpoint(min, max, breakpoints, currentBreakpoint, true), [breakpoints, currentBreakpoint]);
  const above = useCallback(value => withinBreakpoint(value, Infinity, breakpoints, currentBreakpoint, false), [breakpoints, currentBreakpoint]);
  const below = useCallback(value => withinBreakpoint(-1, value, breakpoints, currentBreakpoint, false), [breakpoints, currentBreakpoint]);
  return {
    currentBreakpoint,
    within,
    above,
    below
  };
};
var useBreakpoints$1 = useBreakpoints;

export { useBreakpoints$1 as default };
//# sourceMappingURL=useBreakpoints.js.map
